<template>
  <div v-if="errorMessage" class="spinner-overlay" :style="{ height }">
    <div class="spinner-text">{{ errorMessage }}</div>
  </div>
  <div v-else-if="isLoading" class="spinner-overlay" :style="{ height }">
    <spinner-component />
    <div class="spinner-text">
      {{ iceState ? iceStateMessage : 'Waiting For connection...' }}
    </div>
  </div>
  <video
    v-show="!isLoading && !errorMessage"
    ref="video"
    class="w-100"
    :style="{ height }"
    autoplay
    playsinline
    muted
    controls
  />
</template>
<script>
import SpinnerComponent from '../../../shared/Components/Spinner';
import httpClient from '@/service/httpClient';
import WebRtc from 'src/services/webrtc';
import { MediaRTCConnection } from '../devices/ProjectiorRegion/webrtc';
import { mapGetters } from 'vuex';

export default {
  components: { SpinnerComponent },
  inject: ['toast'],
  props: {
    serialNumber: { type: String, default: null },
    deviceSettings: { type: Object, default: () => ({}) },
    // CSS height of the player; the parent can pass e.g. '100%' to embed it.
    height: { type: String, default: '600px' }
  },
  emits: ['closeModal', 'connected', 'failed'],
  data() {
    return {
      video: null,
      videoParams: null,
      cssPhysicalProportion: 1,
      videoWidth: 640,
      rtcConfiguration: {},
      deviceMac: null,
      isLoading: true,
      rtcConn: null,
      answerSearching: null,
      iceState: null,
      iceStateMessage: null,
      errorMessage: null
    };
  },
  computed: {
    ...mapGetters(['organization', 'fcmToken'])
  },
  watch: {
    iceState(value) {
      console.log('ice state->', value);
      if (value === 'failed') {
        console.log('icestate failed', value);
        this.iceStateMessage = 'Live Stream Failed';
        this.$emit('failed', this.iceStateMessage);
        this.$emit('closeModal');
      } else if (value === 'disconnected') {
        console.log('icestate disconnected', value);
        // this.isLoading = true;
        // this.iceStateMessage = 'Slow network detected. Trying to reconnect...';
        // this.toast.info('Slow network detected. Trying to reconnect...');
      } else if (value === 'connected') {
        this.iceStateMessage = 'Live Stream Connected';
        this.isLoading = false;
        this.$emit('connected');
      } else if (value === 'checking') {
        this.isLoading = true;
        this.iceStateMessage = 'Checking For Connection...';
      }
    }
  },
  created() {
    this.deviceMac = this.serialNumber;
  },
  mounted() {
    this.video = this.$refs.video;
    this.video.addEventListener('canplay', () => {
      this.play();
    });
    this.showStream();
  },
  beforeUnmount() {
    // showStream() may still be awaiting; it checks this flag before going on.
    this.destroyed = true;
    if (this.answerHandler)
      this.emitter.off(this.serialNumber, this.answerHandler);
    if (this.mediaConnection) this.mediaConnection.close();
    clearInterval(this.answerSearching);
  },
  methods: {
    play() {
      // Rejects if the stream is torn down before playback starts.
      this.video.play()?.catch(() => {});
    },
    async showStream() {
      // this.initRTCConnection();
      console.log('showStream');
      try {
        this.rtcConfiguration = await WebRtc.getRTCServers(
          this.deviceSettings?.ice_options
        );
        if (this.destroyed) return;
        this.mediaConnection = new MediaRTCConnection(
          this.serialNumber,
          this.organization,
          this.fcmToken,
          this.video,
          this.rtcConfiguration,
          this.setIceState
        );
        this.mediaConnection.onFailure = this.handleFailure;
        await this.mediaConnection.connectToRemotePeer();
        if (this.destroyed) return;
        console.log(this.mediaConnection);
        this.answerHandler = this.mediaConnection.setRTCRemoteDescription.bind(
          this.mediaConnection
        );
        this.emitter.on(this.serialNumber, this.answerHandler);
      } catch (error) {
        this.handleFailure(
          typeof error === 'string' ? error : 'Could not start the live stream'
        );
      }
    },
    handleFailure(message) {
      if (this.destroyed) return;
      this.errorMessage = message;
      this.$emit('failed', message);
    },
    setIceState: function(value) {
      console.log('ice state', value);
      this.iceState = value;
    },
    setVideoParams() {
      const self = this;
      const modalBody = document.getElementById('stream-modal-body');
      setTimeout(() => {
        const { top, left, width, height } = self.video.getBoundingClientRect();
        const modalParams = modalBody?.getBoundingClientRect();
        self.videoParams = {
          top: Math.floor(top - modalParams.top),
          left: Math.floor(left - modalParams.left),
          width: Math.floor(width),
          height: Math.floor(height)
        };
        self.cssPhysicalProportion = self.videoWidth / width;
      }, 2000);
    }
  }
};
</script>
<style scoped>
.video-container {
  height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.spinner-overlay {
  /* position: absolute; */
  top: 0;
  left: 0;
  width: 100%;
  height: 600px;
  /* Semi-transparent background for the overlay */
  /* background: rgba(
    255,
    255,
    255,
    0.8
  );  */
  display: flex;
  justify-content: center;
  align-items: center;
  /* z-index: 1;  */
  text-align: center;
  flex-direction: column;
}
.spinner-text {
  margin-top: 10px; /* Add some spacing between the spinner and text */
}
</style>
